import {Link} from "@tiptap/extension-link";

const normalizeLinkHref = value => {
    const href = value.trim();

    if (/^(https?:\/\/|mailto:|\/|#)/i.test(href)) return href;
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(href)) return `mailto:${href}`;

    return `https://${href}`;
};

const getTextSelection = editor => {
    const {from, to, empty, $from} = editor.state.selection;

    if (!empty) {
        return {
            from,
            to,
            text: editor.state.doc.textBetween(from, to, " ").trim(),
        };
    }

    if (!$from.parent.isTextblock) return null;

    const textBeforeCursor = $from.parent.textBetween(0, $from.parentOffset, " ");
    const textAfterCursor = $from.parent.textBetween($from.parentOffset, $from.parent.content.size, " ");
    const textBefore = textBeforeCursor.match(/\S+$/)?.[0] ?? "";
    const textAfter = textAfterCursor.match(/^\S+/)?.[0] ?? "";
    const text = `${textBefore}${textAfter}`;

    if (!text) return null;

    return {
        from: from - textBefore.length,
        to: from + textAfter.length,
        text,
    };
};

export const toggleTextLink = editor => {
    if (!editor || editor.isDestroyed) return false;

    if (editor.isActive("link")) {
        return editor.chain().focus().extendMarkRange("link").unsetLink().run();
    }

    const selection = getTextSelection(editor);
    if (!selection?.text) return false;

    return editor.chain()
        .focus()
        .setTextSelection({from: selection.from, to: selection.to})
        .setLink({href: normalizeLinkHref(selection.text)})
        .run();
};

const RichTextLinkExtension = Link.extend({
    addKeyboardShortcuts() {
        return {
            "Mod-k": () => toggleTextLink(this.editor),
        };
    },
}).configure({openOnClick: true});

export default RichTextLinkExtension;
